// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stock-table {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.stock-table__upper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: end;
}
.stock-table__upper__controls {
  display: flex;
  flex-direction: row;
  justify-content: end;
  height: fit-content;
  gap: 0.5rem;
}
.stock-table__upper__controls__add-button {
  width: 150px;
  height: 40px;
  background-color: #4F4BFF;
  color: white;
  border-color: #DEDEDE;
  border-radius: 6px;
  font-size: 0.85rem;
}
.stock-table__upper__controls__filter-button {
  width: fit-content;
  height: 40px;
  background-color: transparent;
  color: black;
  border-color: #DEDEDE;
  border-radius: 6px;
  font-size: 0.85rem;
}
.stock-table__upper__controls .p-inputgroup {
  position: relative;
}
.stock-table__upper__controls .p-inputgroup .p-inputgroup-addon {
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  background: none;
  border: none;
  color: #64748B;
}
.stock-table__upper__controls .p-inputgroup .p-inputtext {
  padding-left: 2.5rem;
  width: 100%;
}
.stock-table__table {
  height: 55vh;
  overflow-y: auto;
}
.stock-table__table__header {
  padding: 10px 1rem;
  display: grid;
  grid-template-columns: 5% 20% 20% 20% 20% 15%;
  place-items: center;
  background-color: #F9FAFB;
  border-radius: 7px;
  height: 8%;
  font-size: 0.85rem;
}
.stock-table__table__header > * {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.stock-table__table__header .sortable-header {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.stock-table__table__header .sortable-header:nth-child(2) {
  justify-content: flex-start;
  padding-left: 1rem;
}
.stock-table__table__header .sortable-header:not(:nth-child(2)) {
  justify-content: center;
}
.stock-table__table__header .sortable-header:hover {
  color: #4F4BFF;
}
.stock-table__table__header .sortable-header .pi {
  font-size: 0.75rem;
}
.stock-table__lower-controls {
  height: fit-content;
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
}
.stock-table__lower-controls__rows-per-page, .stock-table__lower-controls__visible-rows {
  font-size: 0.85rem;
  color: #64748B;
  margin-right: 75px;
}
.stock-table__lower-controls__button {
  width: 110px;
  height: 40px;
  background-color: transparent;
  color: #726BEA;
  border-color: #DEDEDE;
  border-radius: 6px;
  font-size: 0.85rem;
  margin-right: 10px;
}
.stock-table__lower-controls .disabled {
  color: #DEDEDE;
  pointer-events: none;
}
.stock-table__filter-container {
  position: relative;
}
.stock-table__filter-container .filters-active {
  background-color: #4F4BFF;
  color: white;
}
.stock-table__filter-container .filters-active:hover {
  background-color: #3f3ccc;
}
.stock-table__filters-popup {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: white;
  border: 1px solid #ECECEC;
  border-radius: 8px;
  padding: 1.25rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  z-index: 1000;
  min-width: 250px;
  max-height: 400px;
  overflow-y: auto;
}
.stock-table__filters-popup__item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  cursor: pointer;
  border-radius: 6px;
}
.stock-table__filters-popup__item label {
  cursor: pointer;
  margin-left: 0.25rem;
  color: #1E293B;
  font-size: 0.9rem;
}
.stock-table__filters-popup__item:hover {
  background: #F8F9FA;
}
.stock-table__filters-popup::-webkit-scrollbar {
  width: 8px;
}
.stock-table__filters-popup::-webkit-scrollbar-track {
  background: #F8F9FA;
  border-radius: 4px;
}
.stock-table__filters-popup::-webkit-scrollbar-thumb {
  background: #E2E8F0;
  border-radius: 4px;
}
.stock-table__filters-popup::-webkit-scrollbar-thumb:hover {
  background: #CBD5E1;
}

.p-checkbox.p-highlight .p-checkbox-box {
  background-color: #4F4BFF;
}

@media screen and (max-width: 768px) {
  .stock-table {
    height: calc(100vh - 200px);
    overflow-y: auto;
  }
  .stock-table__upper {
    position: sticky;
    top: calc(var(--header-height, 100px)); /* Adjust this value based on your header height */
    background-color: white;
    z-index: 10;
    padding: 1rem;
    border-bottom: 1px solid #ECECEC;
  }
  .stock-table__upper__controls {
    gap: 0.5rem;
  }
  .stock-table__upper__controls__add-button {
    display: none;
  }
  .stock-table__upper__controls__filter-button {
    width: 40px;
    height: 40px;
    font-size: 0.9rem;
    padding: 0.75rem;
  }
  .stock-table__upper__controls__filter-button .pi {
    font-size: 1.5rem;
  }
  .stock-table__upper__controls__save-button {
    width: 40px;
    height: 40px;
    background-color: #4F4BFF;
    font-size: 2rem;
  }
  .stock-table__upper__controls__save-button .pi {
    font-size: 1.5rem;
  }
  .stock-table__upper__controls .p-inputtext {
    height: 40px;
    font-size: 0.9rem;
    padding: 0.75rem;
  }
  .stock-table__table {
    height: auto;
    overflow: visible;
  }
  .stock-table__table__header {
    display: none;
  }
  .stock-table__table__mobile-item {
    display: flex;
    padding: 1.25rem 1rem;
    border-bottom: 1px solid #ECECEC;
  }
  .stock-table__table__mobile-item__info {
    width: 20%;
    padding-right: 0.5rem;
  }
  .stock-table__table__mobile-item__info__name {
    font-weight: 500;
    margin-bottom: 0.5rem;
    font-size: 1rem;
  }
  .stock-table__table__mobile-item__info__total {
    color: #64748B;
    font-size: 0.9rem;
  }
  .stock-table__table__mobile-item__cells {
    width: 80%;
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
  }
  .stock-table__table__mobile-item__cells__column {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem 0;
    border-bottom: 1px solid #f5f5f5;
  }
  .stock-table__table__mobile-item__cells__column:last-child {
    border-bottom: none;
  }
  .stock-table__table__mobile-item__cells__column__header {
    font-size: 1.1rem;
    color: #64748B;
    font-weight: 600;
    background-color: #F8F9FA;
    padding: 0.5rem;
    border-radius: 4px;
    width: 100%;
    text-align: center;
  }
  .stock-table__lower-controls {
    display: none; /* Hide lower controls on mobile */
  }
  .stock-table__filter-container {
    position: static;
  }
  .stock-table__filter-backdrop {
    display: none;
  }
  .stock-table__filters-popup {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    max-width: 400px;
    max-height: 80vh;
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 1000;
  }
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/stock-table/stock-table.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACJ;AAAI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAER;AADQ;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;AAGZ;AAFY;EACI,YAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAIhB;AADY;EACI,kBAAA;EACA,YAAA;EACA,6BAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAGhB;AADY;EACI,kBAAA;AAGhB;AADgB;EACI,kBAAA;EACA,aAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;AAGpB;AAAgB;EACI,oBAAA;EACA,WAAA;AAEpB;AAGI;EACI,YAAA;EACA,gBAAA;AADR;AAEQ;EACI,kBAAA;EACA,aAAA;EACA,6CAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;AAAZ;AAEY;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAhB;AAGY;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AADhB;AAGgB;EACI,2BAAA;EACA,kBAAA;AADpB;AAIgB;EACI,uBAAA;AAFpB;AAKgB;EACI,cAAA;AAHpB;AAMgB;EACI,kBAAA;AAJpB;AASI;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;AAPR;AASQ;EAEI,kBAAA;EACA,cAAA;EACA,kBAAA;AARZ;AAWQ;EACI,YAAA;EACA,YAAA;EACA,6BAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AATZ;AAWQ;EACI,cAAA;EACA,oBAAA;AATZ;AAYI;EACI,kBAAA;AAVR;AAYQ;EACI,yBAAA;EACA,YAAA;AAVZ;AAYY;EACI,yBAAA;AAVhB;AAcI;EACI,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,0CAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAZR;AAcQ;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAZZ;AAcY;EACI,eAAA;EACA,oBAAA;EACA,cAAA;EACA,iBAAA;AAZhB;AAeY;EACI,mBAAA;AAbhB;AAiBQ;EACI,UAAA;AAfZ;AAkBQ;EACI,mBAAA;EACA,kBAAA;AAhBZ;AAmBQ;EACI,mBAAA;EACA,kBAAA;AAjBZ;AAmBY;EACI,mBAAA;AAjBhB;;AAuBA;EACI,yBAAA;AApBJ;;AAuBA;EACE;IACE,2BAAA;IACA,gBAAA;EApBF;EAsBE;IACE,gBAAA;IACA,sCAAA,EAAA,kDAAA;IACA,uBAAA;IACA,WAAA;IACA,aAAA;IACA,gCAAA;EApBJ;EAsBI;IACE,WAAA;EApBN;EAsBM;IACE,aAAA;EApBR;EAuBM;IACE,WAAA;IACA,YAAA;IACA,iBAAA;IACA,gBAAA;EArBR;EAsBQ;IACE,iBAAA;EApBV;EAuBM;IACI,WAAA;IACA,YAAA;IACA,yBAAA;IACA,eAAA;EArBV;EAsBU;IACE,iBAAA;EApBZ;EAuBM;IACE,YAAA;IACA,iBAAA;IACA,gBAAA;EArBR;EA0BE;IACE,YAAA;IACA,iBAAA;EAxBJ;EA0BI;IACE,aAAA;EAxBN;EA2BI;IACE,aAAA;IACA,qBAAA;IACA,gCAAA;EAzBN;EA2BM;IACE,UAAA;IACA,qBAAA;EAzBR;EA2BQ;IACE,gBAAA;IACA,qBAAA;IACA,eAAA;EAzBV;EA4BQ;IACE,cAAA;IACA,iBAAA;EA1BV;EA8BM;IACE,UAAA;IACA,aAAA;IACA,sBAAA;IACA,YAAA;EA5BR;EA8BQ;IACE,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,YAAA;IACA,kBAAA;IACA,gCAAA;EA5BV;EA8BU;IACE,mBAAA;EA5BZ;EA+BU;IACE,iBAAA;IACA,cAAA;IACA,gBAAA;IACA,yBAAA;IACA,eAAA;IACA,kBAAA;IACA,WAAA;IACA,kBAAA;EA7BZ;EAoCE;IACE,aAAA,EAAA,kCAAA;EAlCJ;EAqCE;IACE,gBAAA;EAnCJ;EAsCE;IACE,aAAA;EApCJ;EAuCE;IACE,eAAA;IACA,QAAA;IACA,SAAA;IACA,gCAAA;IACA,UAAA;IACA,gBAAA;IACA,gBAAA;IACA,iBAAA;IACA,kBAAA;IACA,0CAAA;IACA,aAAA;EArCJ;AACF","sourcesContent":[".stock-table{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    &__upper{\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: end;\n        &__controls{\n            display: flex;\n            flex-direction: row;\n            justify-content: end;\n            height: fit-content;\n            gap: 0.5rem;\n            &__add-button{\n                width: 150px;\n                height: 40px;\n                background-color:#4F4BFF;\n                color: white;\n                border-color: #DEDEDE;\n                border-radius: 6px;\n                font-size: 0.85rem;\n            }\n\n            &__filter-button{\n                width: fit-content;\n                height: 40px;\n                background-color:transparent;\n                color: black;\n                border-color: #DEDEDE;\n                border-radius: 6px;\n                font-size: 0.85rem;\n            }\n            .p-inputgroup {\n                position: relative;\n                \n                .p-inputgroup-addon {\n                    position: absolute;\n                    left: 0.75rem;\n                    top: 50%;\n                    transform: translateY(-50%);\n                    z-index: 1;\n                    background: none;\n                    border: none;\n                    color: #64748B;\n                }\n                \n                .p-inputtext {\n                    padding-left: 2.5rem;\n                    width: 100%;\n                }\n            }\n        }\n    }\n    &__table{\n        height: 55vh;\n        overflow-y:auto;\n        &__header{\n            padding: 10px 1rem;\n            display: grid;\n            grid-template-columns: 5% 20% 20% 20% 20% 15%;\n            place-items: center;\n            background-color: #F9FAFB;\n            border-radius: 7px;\n            height: 8%;\n            font-size: 0.85rem;\n            \n            > * {\n                width: 100%;\n                height: 100%;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n            }\n            \n            .sortable-header {\n                width: 100%;\n                display: flex;\n                align-items: center;\n                gap: 0.5rem;\n                cursor: pointer;\n                user-select: none;\n                \n                &:nth-child(2) {\n                    justify-content: flex-start;\n                    padding-left: 1rem;\n                }\n                \n                &:not(:nth-child(2)) {\n                    justify-content: center;\n                }\n                \n                &:hover {\n                    color: #4F4BFF;\n                }\n                \n                .pi {\n                    font-size: 0.75rem;\n                }\n            }\n        }\n    }\n    &__lower-controls{\n        height: fit-content;\n        display: flex;\n        flex-direction: row;\n        justify-content: end;\n        align-items: center;\n\n        &__rows-per-page,\n        &__visible-rows{\n            font-size: 0.85rem;\n            color: #64748B;\n            margin-right: 75px;\n        }\n        \n        &__button{\n            width: 110px;\n            height: 40px;\n            background-color:transparent;\n            color: #726BEA;\n            border-color: #DEDEDE;\n            border-radius: 6px;\n            font-size: 0.85rem;\n            margin-right: 10px;\n        }\n        .disabled{\n            color: #DEDEDE;\n            pointer-events: none;\n        }\n    }\n    &__filter-container {\n        position: relative;\n        \n        .filters-active {\n            background-color: #4F4BFF;\n            color: white;\n            \n            &:hover {\n                background-color: #3f3ccc;\n            }\n        }\n    }\n    &__filters-popup {\n        position: absolute;\n        top: calc(100% + 8px);\n        right: 0;\n        background: white;\n        border: 1px solid #ECECEC;\n        border-radius: 8px;\n        padding: 1.25rem;\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n        z-index: 1000;\n        min-width: 250px;\n        max-height: 400px;\n        overflow-y: auto;\n\n        &__item {\n            display: flex;\n            align-items: center;\n            gap: 0.75rem;\n            padding: 0.75rem;\n            cursor: pointer;\n            border-radius: 6px;\n\n            label {\n                cursor: pointer;\n                margin-left: 0.25rem;\n                color: #1E293B;\n                font-size: 0.9rem;\n            }\n\n            &:hover {\n                background: #F8F9FA;\n            }\n        }\n\n        &::-webkit-scrollbar {\n            width: 8px;\n        }\n\n        &::-webkit-scrollbar-track {\n            background: #F8F9FA;\n            border-radius: 4px;\n        }\n\n        &::-webkit-scrollbar-thumb {\n            background: #E2E8F0;\n            border-radius: 4px;\n            \n            &:hover {\n                background: #CBD5E1;\n            }\n        }\n    }\n}\n\n.p-checkbox.p-highlight .p-checkbox-box{\n    background-color: #4F4BFF ;\n}\n\n@media screen and (max-width: 768px) {\n  .stock-table {\n    height: calc(100vh - 200px);\n    overflow-y: auto;\n    \n    &__upper {\n      position: sticky;\n      top: calc(var(--header-height, 100px)); /* Adjust this value based on your header height */\n      background-color: white;\n      z-index: 10;\n      padding: 1rem;\n      border-bottom: 1px solid #ECECEC;\n      \n      &__controls {\n        gap: 0.5rem;\n        \n        &__add-button {\n          display: none;\n        }\n        \n        &__filter-button {\n          width: 40px;\n          height: 40px;\n          font-size: 0.9rem;\n          padding: 0.75rem;\n          .pi{\n            font-size: 1.5rem;\n          }\n        }\n        &__save-button{\n            width: 40px;\n            height: 40px;\n            background-color: #4F4BFF;\n            font-size: 2rem;\n            .pi{\n              font-size: 1.5rem;\n            }\n        }\n        .p-inputtext {\n          height: 40px;\n          font-size: 0.9rem;\n          padding: 0.75rem;\n        }\n      }\n    }\n\n    &__table {\n      height: auto;\n      overflow: visible;\n      \n      &__header {\n        display: none;\n      }\n      \n      &__mobile-item {\n        display: flex;\n        padding: 1.25rem 1rem;\n        border-bottom: 1px solid #ECECEC;\n        \n        &__info {\n          width: 20%;\n          padding-right: 0.5rem;\n          \n          &__name {\n            font-weight: 500;\n            margin-bottom: 0.5rem;\n            font-size: 1rem;\n          }\n          \n          &__total {\n            color: #64748B;\n            font-size: 0.9rem;\n          }\n        }\n        \n        &__cells {\n          width: 80%;\n          display: flex;\n          flex-direction: column;\n          gap: 1.25rem;\n          \n          &__column {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            gap: 0.75rem;\n            padding: 0.75rem 0;\n            border-bottom: 1px solid #f5f5f5;\n            \n            &:last-child {\n              border-bottom: none;\n            }\n            \n            &__header {\n              font-size: 1.1rem;\n              color: #64748B;\n              font-weight: 600;\n              background-color: #F8F9FA;\n              padding: 0.5rem;\n              border-radius: 4px;\n              width: 100%;\n              text-align: center;\n            }\n          }\n        }\n      }\n    }\n    \n    &__lower-controls {\n      display: none; /* Hide lower controls on mobile */\n    }\n\n    &__filter-container {\n      position: static;\n    }\n\n    &__filter-backdrop {\n      display: none;\n    }\n\n    &__filters-popup {\n      position: fixed;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      width: 90%;\n      max-width: 400px;\n      max-height: 80vh;\n      background: white;\n      border-radius: 8px;\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n      z-index: 1000;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
